/**
 * The country drives how a zone's coverage is managed: Chilean zones are built
 * commune by commune, Mexican ones are loaded from a postal-code spreadsheet.
 * Which endpoints run on save depends on this value.
 */
export const ZONE_COUNTRIES = {
  CL: 'CL',
  MX: 'MX',
};

/** @type {Array<{value: string, label: string}>} */
export const COUNTRY_OPTIONS = [
  { value: ZONE_COUNTRIES.CL, label: 'Chile (selección manual de comunas)' },
  { value: ZONE_COUNTRIES.MX, label: 'México (carga masiva vía Excel)' },
];
